import {Group, NavLink, rem, Title, Box} from '@mantine/core';
import {IconListSearch} from '@tabler/icons-react';
import {useLocation} from "react-router-dom";
import classes from './TableOfContents.module.css';

export function TableOfContents() {
    const currentPage = useLocation().pathname;

    return (
        <Box
            top={136}
            pos='sticky'
            pr="xs"
            pl="xs"
            maw="15rem"
        >
            <Group
                mb="md">
                <Title size="h6" style={{color: 'light-dark(var(--mantine-color-black), #CFD4D6)'}}>
                    TABLE OF CONTENTS
                </Title>
                <IconListSearch style={{width: rem(18), height: rem(18)}} stroke={1.5}/>
            </Group>
            <NavLink
                className={classes.nav}
                href="/docs"
                label="Getting Started"
                variant="filled"
                active={currentPage === "/" || currentPage === "/docs"}
            />
            <NavLink
                className={classes.nav}
                href="/commands"
                label="Commands"
                variant="filled"
                active={currentPage === "/commands"}
                childrenOffset={28}
                defaultOpened>
                <NavLink
                    className={classes.nav}
                    href="/cgr"
                    label="CGR"
                    variant="filled"
                    active={currentPage === "/cgr"}
                />
                <NavLink
                    className={classes.nav}
                    href="/ena"
                    label="ENA"
                    variant="filled"
                    active={currentPage === "/ena"}
                />
                <NavLink
                    className={classes.nav}
                    href="/jellyfish"
                    label="Jellyfish"
                    variant="filled"
                    active={currentPage === "/jellyfish"}
                />
            </NavLink>
            <NavLink
                className={classes.nav}
                href="/config"
                label="Config File"
                variant="filled"
                active={currentPage === "/config"}
            />
        </Box>
    );
}